import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import { NavController } from '@ionic/angular'; // Import NavController

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private storage: Storage, private navCtrl: NavController) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('/api/login')) {
        return next.handle(request);
    }

    return from(this.storage.get('auth_token')).pipe(
      switchMap(token => {
        if (token) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }
        return next.handle(request).pipe(
          // --- THE NEW ERROR CATCHER ---
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // Token is invalid or device was deleted. Clear storage and force login.
              this.storage.remove('auth_token');
              this.storage.remove('sellerclient');
              this.navCtrl.navigateRoot('/login'); // Make sure this matches your login route path
            }
            return throwError(error);
          })
        );
      })
    );
  }
}